import { name, version } from '../../package.json';

export default function(config) {
	config.headers[`x-client-version-${name}`] = version;

	return config;
}
